/**
 * Hierarchical TanStack Query key factory.
 *
 * Keys are arrays so that `invalidateQueries({ queryKey: ["nostr", "user", pubkey] })`
 * clears profile, contacts, and relays in one call.
 */
export const queryKeys = {
  // --- Nostr events ---
  nostr: {
    /** Replaceable events: kind 30000+, parameterized by pubkey + d-tag */
    replaceable: (kind: number, pubkey: string, identifier?: string) =>
      ["nostr", "replaceable", kind, pubkey, identifier] as const,

    /** Timeline feeds */
    timeline: (key: string, filterHash: string) => ["nostr", "timeline", key, filterHash] as const,

    /** Zaps on an event */
    zaps: (eventId: string) => ["nostr", "zaps", eventId] as const,

    /** Nutzaps on an event */
    nutzaps: (eventId: string) => ["nostr", "nutzaps", eventId] as const,

    /** User data (profile, contacts, relays) — all share the ["nostr", "user", pubkey] prefix */
    user: {
      all: (pubkey: string) => ["nostr", "user", pubkey] as const,
      profile: (pubkey: string) => ["nostr", "user", pubkey, "profile"] as const,
      contacts: (pubkey: string) => ["nostr", "user", pubkey, "contacts"] as const,
      relays: (pubkey: string) => ["nostr", "user", pubkey, "relays"] as const,
    },

    /** Encrypted kind 30078 account state */
    accountState: (pubkey: string, dtag: string) => ["nostr", "accountState", pubkey, dtag] as const,
  },

  // --- Markets ---
  markets: {
    oracle: (pubkey: string) => ["markets", "oracle", pubkey] as const,
    orderbook: (pair: string) => ["markets", "orderbook", pair] as const,
    myOrders: (pubkey: string) => ["markets", "myOrders", pubkey] as const,
  },

  // --- NWC (Nostr Wallet Connect) ---
  nwc: {
    balance: (walletPubkey: string) => ["nwc", "balance", walletPubkey] as const,
    transactions: (walletPubkey: string) => ["nwc", "transactions", walletPubkey] as const,
  },
} as const;
